export function SunIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.236 5.918L5.6 4.283 4.318 5.571l1.627 1.634 1.291-1.287zm-2.509 5.169H2v1.826h2.727v-1.826zM12.91 2h-1.818v2.694h1.818V2zm6.773 3.57L18.4 4.284l-1.627 1.635 1.282 1.287 1.627-1.634zm-2.918 12.512l1.627 1.644 1.282-1.288-1.637-1.634-1.272 1.278zm2.509-6.995v1.826H22v-1.826h-2.727zM12 6.52C8.99 6.52 6.545 8.977 6.545 12S8.991 17.48 12 17.48c3.01 0 5.454-2.457 5.454-5.48 0-3.023-2.445-5.48-5.454-5.48zM11.09 22h1.82v-2.694h-1.82V22zm-6.772-3.57L5.6 19.716l1.627-1.644-1.282-1.288-1.627 1.644z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
